import React, { useState, useCallback } from "react";
import PT from "prop-types";
import { Wrap, AppliedSect, CreateSect, Head } from "./styled";
import isempty from "lodash/isEmpty";
import List from "./List";
import Form from "./Form";
import { Button } from "_c/button";
import Empty from "_c/Empty";
import PlusIcon from "_c/icon/Plus";
import Animated from "_c/Animated";
import {
  useCanCreateMorePublicDiscountsForAll,
  useCanCreateMorePublicDiscountsForService,
  useGetAllowedClientsForService,
  useGetAllowedClientsForAll,
  useClients,
} from "./hooks";

const ns = "common:discount_editor";
const DiscountEditor = (props) => {
  const clients = useClients(props.disableClientPicker);
  const [formOpen, setFormOpen] = useState(false);
  const [activeDiscount, setActiveDiscount] = useState(null);
  const openForm = useCallback((discount) => {
    setActiveDiscount(discount);
    setFormOpen(true);
  }, []);
  const closeForm = useCallback(() => {
    setActiveDiscount(null);
    setFormOpen(false);
  }, []);
  const canCreateMorePublicDiscountsForAll =
    useCanCreateMorePublicDiscountsForAll({
      activeDiscount,
      discounts: props.discounts,
    });
  const canCreateMorePublicDiscountsForService =
    useCanCreateMorePublicDiscountsForService({
      activeDiscount,
      discounts: props.discounts,
    });
  const allowedClientsForService = useGetAllowedClientsForService({
    activeDiscount,
    clients,
    discounts: props.discounts,
  });
  const allowedClientsForAll = useGetAllowedClientsForAll({
    clients,
    activeDiscount,
    discounts: props.discounts,
  });
  const hasDiscounts = !isempty(props.discounts);
  const formId = `bonus-editor__${props.service}`;
  return (
    <Wrap id={`${formId}-container`}>
      <AppliedSect>
        {hasDiscounts && <Head>{props.t(`${ns}.active_discounts`)}:</Head>}
        {!hasDiscounts ? (
          <Empty centered={false} message={props.t(`${ns}.empty`)} />
        ) : (
          <List
            t={props.t}
            ns={ns}
            activeDiscount={activeDiscount}
            openForm={openForm}
            closeForm={closeForm}
            discounts={props.discounts}
            deleteDiscount={props.deleteDiscount}
          />
        )}

        <Button
          withIcon
          medium
          greenish
          style={{ marginTop: "20px", paddingBottom: "14px" }}
          onClick={() => openForm(null)}
        >
          <PlusIcon color="white" />
          <span>{props.t(`${ns}.new`)}</span>
        </Button>
      </AppliedSect>
      <Animated visible={formOpen}>
        <CreateSect>
          <Form
            t={props.t}
            ns={ns}
            formId={formId}
            canCreateMorePublicDiscountsForAll={
              canCreateMorePublicDiscountsForAll
            }
            canCreateMorePublicDiscountsForService={
              canCreateMorePublicDiscountsForService
            }
            onClose={closeForm}
            masterId={props.masterId}
            service={props.service}
            clients={clients}
            disableClientPicker={props.disableClientPicker}
            allowedClientsForAll={allowedClientsForAll}
            allowedClientsForService={allowedClientsForService}
            createDiscount={props.createDiscount}
            updateDiscount={props.updateDiscount}
            discount={activeDiscount}
          />
        </CreateSect>
      </Animated>
    </Wrap>
  );
};
DiscountEditor.propTypes = {
  discounts: PT.array.isRequired,
  service: PT.string,
  masterId: PT.string.isRequired,
  disableClientPicker: PT.bool,

  t: PT.func.isRequired,
  deleteDiscount: PT.func.isRequired,
  createDiscount: PT.func.isRequired,
  updateDiscount: PT.func.isRequired,
  onClose: PT.func.isRequired,
};
export default DiscountEditor;
